










































































import { Component, PropSync, Vue } from 'vue-property-decorator'

@Component({})
export default class HelpDrawer extends Vue {
  @PropSync('open') show !: boolean;
}
